const formatTime = (time) => {
  const event = new Date(time);
  const newTime = event.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).split(" ").join("");
  return newTime
};

module.exports = formatTime;
